import { IReceiptArgs } from '../../common/interfaces/dtos/IReceiptArgs';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { showDigitalReceiptOptions } from '../components/receipt-modals/print-receipt-options';
import { DigitalReceiptDetails } from '../../common/interfaces/states/TenderingState';

const onCancel = async (resolveHandler): Promise<IReceiptArgs> => {
  popEmeraldModal();
  const receiptDetails: IReceiptArgs = {
    printReceipt: false,
  };
  return resolveHandler(receiptDetails);
};

const onAcceptPrint = async (resolveHandler): Promise<IReceiptArgs> => {
  popEmeraldModal();
  const receiptDetails: IReceiptArgs = {
    printReceipt: true,
  };
  return resolveHandler(receiptDetails);
};

const onAcceptDigital = async (resolveHandler): Promise<IReceiptArgs> => {
  const receiptDetails = await showDigitalReceiptOptions(false);
  popEmeraldModal();
  return resolveHandler(receiptDetails);
};

const onAcceptBoth = async (resolveHandler): Promise<IReceiptArgs> => {
  const receiptDetails = await showDigitalReceiptOptions(true);
  popEmeraldModal();
  return resolveHandler(receiptDetails);
};

const digitalReceiptCancelHandler = () => {
  popEmeraldModal();
};

const digitalReceiptConfirmHandler = (
  isAlsoPrintReceipt: boolean,
  details: Partial<DigitalReceiptDetails>,
): IReceiptArgs => {
  const receiptDetails: IReceiptArgs = {
    printReceipt: isAlsoPrintReceipt,
    emailAddress: details.email,
    mobilePhoneNumber: details.altId,
  };
  popEmeraldModal();
  return receiptDetails;
};

const resolveHandler = (resolve: (receiptDetails: IReceiptArgs) => void) => {
  return (receiptDetails: IReceiptArgs) => resolve(receiptDetails);
};

export const ReceiptOptionsActionHandler = {
  onCancel: onCancel,
  onAcceptPrint: onAcceptPrint,
  onAcceptDigital: onAcceptDigital,
  onAcceptBoth: onAcceptBoth,
  digitalReceiptCancelHandler: digitalReceiptCancelHandler,
  digitalReceiptConfirmHandler: digitalReceiptConfirmHandler,
  resolveHandler: resolveHandler,
};
